(() => {
    try {
        const myInterval = setInterval(imgSize, 3000);

        function imgSize() {
            document.querySelectorAll('img').forEach(function (element, index) {
                var height = element.clientHeight;
                var width = element.clientWidth;
                var attr = element.getAttribute('height');

                if (!attr) {
                    element.setAttribute('height', height);
                    element.setAttribute('width', width);
                    stop();
                }
            });
        }

        function stop() {
            clearInterval(myInterval);
        }
    } catch (error) {
        console.log('error');
    }
})();